import React from "react";
import RichText from "components/rich-text";
import Image from "components/image";
import Link from "components/link";
import Form from "../form";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation, Mousewheel, Autoplay } from "swiper/modules";

const SplitContentLayout = ({ data }) => {
	const { partnerLogos, title, subtitle, showLoginOption, layout, tag } = data;
	const isSlider = partnerLogos.length > 3;
	const swiperSettings = isSlider
		? {
			modules: [Navigation, Mousewheel, Autoplay],
			loop: true,
			speed: 6000,
			mousewheel: { enabled: true, forceToAxis: true },
			autoplay: { delay: 0, disableOnInteraction: false },
			slidesPerView: 4,
			breakpoints: { 992: { enabled: false } },
		}
		: {};

	return (
		<>
			<div id="modProForm" className="flex w-full flex-col lg:flex-row">
				{data.leftContent &&
					<div style={{ backgroundImage: `url(${data.contentBgImage})` }}
						className=" text-white flex lg:w-1/2 bg-conver bg-center">
						<div className="bg-[#000000b3] size-full flex py-12 lg:py-0">
							<div className="flex flex-col gap-6 m-auto max-w-xl px-4">
								<RichText data={{ content: data.leftContent }} />
								<div className="b2b-split-content w-full">
									<Swiper {...swiperSettings}
										className="flex w-full overflow-auto no-scrollbar">
										{data.partnerLogos?.map((logo, index) => (
											<SwiperSlide key={index} className="mr-4 mx-auto !w-1/4 lg:!w-full">
												<Image key={index} image={logo} className="w-full" />
											</SwiperSlide>
										))}
									</Swiper>
								</div>
							</div>
						</div>
					</div>
				}
				<div className="py-6 lg:py-12 lg:pl-16 lg:pr-20 px-4 flex-col items-center lg:w-1/2 bg-cream">
					<div>
						<p className="text-[#713FFE] bg-[#F1ECFE] px-4 py-1.5 w-fit font-bold mb-5">
							Up to 25% off and exclusive access
						</p>
						{title && <h3 className="font-base text-[40px] font-semibold">{title}</h3>}
						{subtitle && <h5 className="pt-3">{subtitle}</h5>}
						<Form className="form-grid"
							buttonClass="col-span-2 pt-4"
							dropDownOptions
							buttonText="join for free today"
							layout={layout} tag={tag} />
						{showLoginOption &&
							<p className="uppercase w-full text-center font-bold">
								Already a pro?
								<Link to="/account/login" className="ml-1 underline t-already-pro">
									Log in here
								</Link>
							</p>
						}
					</div>
				</div>
			</div>
			<div className="flex flex-col md:flex-row items-center p-5 w-full justify-center bg-beige gap-4 md:gap-0">
				<div className="flex items-center justify-center gap-3">
					<Image image={data.contactImage} className="size-14" />
					<p className="font-bold">Available 24/7</p>
				</div>
				<span className="px-10 hidden md:flex">|</span>
				<div className="flex flex-col md:flex-row items-center justify-center font-semibold text-center">
					<span>Contact support<Link to="/contact"> 1-888-988-4317 or</Link></span>
					<span className="pl-1">email<Link to="/contact"> info@mod-lighting.com</Link></span>
				</div>
			</div>
		</>
	);
};

export default SplitContentLayout;